<template>
  <div
    class="container"
    :style="{ backgroundColor: bgColor }"
  >
    <div class="header">
      <van-image
        width="100%"
        v-bind:src="envData.image"
      ></van-image>
    </div>
    <div
      class="countDown"
      v-if="timeStatus == 'unstart'"
    >
      <van-icon
        :name="require('../assets/image/colon.png')"
        size="27"
      />
      <span class="colon">活动未开始</span>
    </div>
    <div
      class="countDown"
      v-if="timeStatus == 'start'"
    >
      <van-icon
        :name="require('../assets/image/colon.png')"
        size="27"
      />
      <van-count-down
        :time="time"
        @finish="onFinish"
      >
        <template #default="timeData">
          <span
            class="colon"
            style="margin-right: 0.5vw"
          >
            距抽奖结束还剩</span
          >
          <span class="block">{{ timeData.days }}</span>
          <span class="colon">天</span>
          <!-- 小于10自动补0 -->
          <span class="block">{{
            timeData.hours < 10 ? "0" + timeData.hours : timeData.hours
          }}</span>
          <span class="colon">时</span>
          <span class="block">{{
            timeData.minutes < 10 ? "0" + timeData.minutes : timeData.minutes
          }}</span>
          <span class="colon">分</span>
          <span class="block">
            {{
              timeData.seconds < 10 ? "0" + timeData.seconds : timeData.seconds
            }}</span
          >
          <span class="colon">秒</span>
        </template>
      </van-count-down>
    </div>
    <div
      class="countDown"
      v-if="timeStatus == 'end'"
    >
      <van-icon
        :name="require('../assets/image/colon.png')"
        size="27"
      />
      <span class="colon">活动已结束</span>
    </div>
    <div class="content-top">
      <div class="new-content-box">
        <div
          ref="descRef"
          class="content-top-desc"
          :class="{ expand: !isExpand }"
          v-html="envData.statement"
        ></div>
        <div
          v-if="statementOverflows"
          class="tip-expand"
          @click="toggleExpand"
        >
          {{ isExpand ? "收起" : "查看更多" }}
        </div>
      </div>
    </div>
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="form-content">
          <div class="title">姓名<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="name"
            name="name"
            type="text"
            placeholder="请输入您的姓名"
            :rules="[{ required: true, message: '请输入您的姓名' }]"
          />
          <div class="title">联系电话<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="tel"
            name="tel"
            type="tel"
            placeholder="请输入联系电话"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入联系电话' },
              {
                pattern:
                  /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                message: '请填写正确的联系电话'
              }
            ]"
          />
          <div
            v-if="showIdcard"
            class="title"
          >
            身份证号<span class="star">*</span>
          </div>
          <van-field
            v-if="showIdcard"
            class="field"
            v-model="idcard"
            name="idcard"
            type="text"
            placeholder="请输入身份证号"
          />

          <div
            v-if="showImages"
            class="title"
          >
            {{ envData.images_label }}<span class="star">*</span>
          </div>
          <van-field
            v-if="showImages"
            name="images"
          >
            <template #input>
              <van-uploader
                v-model="imagesArray"
                :after-read="handleAfterRead"
                accept="image/*"
                class="uploader"
                @delete="handleDelete"
                :max-count="envData.images_limit || 6"
                :max-size="envData.images_max_size || 5 * 1024 * 1024"
                @oversize="handleOversize"
              />
            </template>
          </van-field>

          <div
            v-if="showAddress && activityId != 116"
            class="title"
          >
            选择领取方式
            <span class="star">*</span>
          </div>
          <van-field
            v-if="showAddress && activityId != 116"
            class="field"
            name="type"
            type="text"
            placeholder="选择领取方式"
            :rules="[{ required: true, message: '选择领取方式' }]"
          >
            <template #input>
              <van-radio-group
                v-model="type"
                direction="horizontal"
              >
                <van-radio name="poster">快递到付</van-radio>
                <van-radio name="self">自行领取</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div
            v-if="showAddress && type == 'poster'"
            class="title"
          >
            收件地址<span class="star">*</span
            ><span v-if="activityId == 116">（限中山市内）</span>
          </div>
          <van-field
            v-if="showAddress && type == 'poster'"
            class="field"
            v-model="address"
            name="address"
            rows="3"
            type="textarea"
            placeholder="请输入收件地址"
          />
          <div
            v-if="showAddress && type == 'poster' && activityId != 116"
            class="title"
          >
            是否同意快递到付
          </div>
          <van-field
            v-if="showAddress && type == 'poster' && activityId != 116"
            name="switch"
          >
            <template #input>
              <van-switch v-model="checked">
                <template #node>
                  <div class="icon-wrapper">
                    {{ checked ? "是" : "否" }}
                  </div>
                </template>
              </van-switch>
            </template>
          </van-field>
        </div>
        <van-button
          class="submit-btn"
          type="success"
          round
          :color="btnColor"
          native-type="submit"
          :disabled="timeStatus != 'start'"
        >
          提交
        </van-button>
      </van-form>
    </div>
    <div class="copyright">中山日报 中山+·有数融媒工作室 出品</div>
  </div>
  <Statement
    :exinfo="exinfo"
    :showJump="showJump"
    @updateJumpState="(state) => (showJump = state)"
  />
</template>

<script>
// import { wxshareInit } from "@/plugins/wechatSDK.js";
import "@/plugins/bridge.js";
import {
  Icon,
  Tabs,
  Tab,
  Button,
  Form,
  Field,
  Dialog,
  Toast,
  Image as VanImage,
  Switch,
  RadioGroup,
  Radio,
  CountDown,
  Uploader
} from "vant";
import { reactive, toRefs, computed, ref, watch, nextTick } from "vue";
import { wxshareInit } from "@/plugins/wechatSDK.js";
import { useRoute } from "vue-router";
import api from "@/api";
import { idcardValid } from "@/utils/util";
import uploadImage from "@/utils/useImageUpload";
import Statement from "@/components/Statement.vue";

export default {
  name: "Home",
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [VanImage.name]: VanImage,
    [Switch.name]: Switch,
    [CountDown.name]: CountDown,
    [Uploader.name]: Uploader,
    Statement
  },
  setup() {
    const route = useRoute();
    const data = reactive({
      name: "",
      tel: "",
      address: "",
      checked: false,
      type: "poster",
      idcard: "",
      imagesArray: [],
      images: "",
      activityId: route.params.activityId
    });
    const { afterRead } = uploadImage();
    const showJump = ref(false);

    const onSubmit = (values) => {
      if (envData.value.idcard_switch) {
        if (!data.idcard) {
          Dialog.alert({
            title: "温馨提示",
            message: "请填写身份证号"
          });
          return;
        }
        const { isPass, errorMessage } = idcardValid(data.idcard);
        if (!isPass) {
          Dialog.alert({
            title: "温馨提示",
            message: errorMessage
          });
          return;
        }
        values["idcard"] = data.idcard.toUpperCase();
      }

      // 图片上传验证
      if (envData.value.images_switch) {
        if (!data.images || !data.images.trim()) {
          Dialog.alert({
            title: "温馨提示",
            message: `请上传${envData.value.images_label || "图片"}`
          });
          return;
        }
        values["images"] = data.images;
      }

      if (
        data.type == "poster" &&
        envData.value.address_switch &&
        !data.address
      ) {
        Dialog.alert({
          title: "温馨提示",
          message: "请填写收件地址"
        });
        return;
      }

      if (
        data.type == "poster" &&
        envData.value.address_switch &&
        !data.checked &&
        data.activityId != 116
      ) {
        Dialog.alert({
          title: "温馨提示",
          message: "请选择同意快递到付"
        });
        return;
      }
      //链式处理数据
      //第一个判断语句要处理一下，微信环境严控不能提交表单，下面的多条件判断是错误的
      const userAgentString = navigator.userAgent.toLowerCase();
      if (
        userAgentString.indexOf("zsrbapp") < 0 &&
        envData.value.info_id &&
        data.activityId != 116
      ) {
        showJump.value = true;
      } else {
        values["activity_id"] = route.params.activityId;
        api.submit(values).then((res) => {
          if (res.code == 1) {
            Dialog.alert({
              message: envData.value.feedback
                ? envData.value.feedback
                : "提交成功"
            }).then(() => {
              if (envData.value.info_id) {
                window.location.href =
                  "https://zsrbapp.zsnews.cn/mobile/news/viewNews/" +
                  envData.value.info_id;
              } else {
                window.history.back();
              }
            });
          } else {
            Toast.fail(res.msg);
          }
        });
      }
    };
    const envData = ref({});
    const time = ref(0);
    const timeStatus = ref("unstart");

    // 在envData定义后再定义这些响应式变量和监听逻辑
    const statementOverflows = ref(false);
    const descRef = ref(null);
    const isExpand = ref(false);

    const toggleExpand = () => {
      isExpand.value = !isExpand.value;
    };

    // 监听 isExpand 变化来设置动画
    watch(isExpand, (newVal) => {
      if (descRef.value) {
        nextTick(() => {
          if (newVal) {
            // 展开
            descRef.value.style.maxHeight = descRef.value.scrollHeight + "px";
          } else {
            // 收起
            descRef.value.style.maxHeight = "120px";
          }
        });
      }
    });

    // 计算属性：检测envData.statement是否超过6行
    const isStatementOverflow = computed(() => {
      if (envData.value.statement) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = envData.value.statement;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";
        const lineHeight = 20; // 假设每行高度为20px
        const maxHeight = lineHeight * 6; // 6行的高度

        // 创建临时元素测量高度
        const measureDiv = document.createElement("div");
        measureDiv.style.position = "absolute";
        measureDiv.style.visibility = "hidden";
        measureDiv.style.width = "calc(100% - 24px)"; // 与.content-top-desc相同的宽度
        measureDiv.style.fontSize = "14px"; // 与.content-top-desc相同的字体大小
        measureDiv.style.padding = "20px"; // 与.content-top-desc相同的padding
        measureDiv.style.boxSizing = "border-box";
        measureDiv.style.borderRadius = "10px";
        measureDiv.innerHTML = envData.value.statement;

        document.body.appendChild(measureDiv);
        const actualHeight = measureDiv.clientHeight;
        document.body.removeChild(measureDiv);

        return actualHeight > maxHeight;
      }
      return false;
    });

    // 监听envData.statement变化
    watch(
      () => envData.value.statement,
      (newVal) => {
        if (newVal) {
          // 使用setTimeout确保DOM已经更新
          setTimeout(() => {
            statementOverflows.value = isStatementOverflow.value;
            // 重置展开状态
            isExpand.value = false;

            // 设置初始最大高度
            if (descRef.value) {
              nextTick(() => {
                if (statementOverflows.value) {
                  descRef.value.style.maxHeight = "120px";
                } else {
                  descRef.value.style.maxHeight = "none";
                }
              });
            }

            console.log(
              "Statement overflows (more than 6 lines):",
              statementOverflows.value
            );
          }, 0);
        }
      }
    );

    api.getEnvData({ id: route.params.activityId }).then((res) => {
      console.log("getEnvData", res);
      const _data = res.data;
      envData.value = _data;
      const shareUrl =
        _data.info_id > 0
          ? `https://zsrbapp.zsnews.cn/mobile/news/viewNews/${_data.info_id}`
          : window.location.href;
      wxshareInit({
        title: _data.share_title,
        imgUrl:
          "https://zsrbactivity.zsnews.cn" +
          require("../assets/image/zsplus.png"),
        description: _data.share_desc,
        url: shareUrl,
        successMethod: ""
      });
      window.ZsrbApp.call("shareInfo", {
        title: _data.share_title,
        img:
          "https://zsrbactivity.zsnews.cn" +
          require("../assets/image/zsplus.png"),
        desc: _data.share_desc,
        url: shareUrl
      });

      const userAgentString = navigator.userAgent.toLowerCase();
      if (
        userAgentString.indexOf("zsrbapp") < 0 &&
        _data.info_id &&
        data.activityId != 116
      ) {
        showJump.value = true;
      }
      // 倒计时和状态
      const currDate = Math.floor(new Date().valueOf() / 1000);
      time.value = (res.data.endtime - currDate) * 1000;
      if (currDate > res.data.starttime) {
        if (currDate < res.data.endtime) {
          timeStatus.value = "start";
          time.value = (res.data.endtime - currDate) * 1000;
        } else {
          timeStatus.value = "end";
        }
      } else {
        timeStatus.value = "unstart";
        time.value = (res.data.starttime - currDate) * 1000;
      }

      console.log(timeStatus.value);
      console.log(time.value);
    });

    const onFinish = () => {
      timeStatus.value = "end";
    };
    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(
        "http://www.zsnews.cn/app/mobile.html?platform=mobile",
        "_blank"
      );
    };

    const handleAfterRead = async (file) => {
      try {
        // 处理单个文件或文件数组
        const files = Array.isArray(file) ? file : [file];

        for (const item of files) {
          const result = await afterRead(item);
          if (result && result.data) {
            if (data.images) {
              data.images += `,${result.data}`;
            } else {
              data.images = `${result.data}`;
            }
          }
        }

        // 确保 imagesArray 始终是数组
        if (!Array.isArray(data.imagesArray)) {
          data.imagesArray = [];
        }
      } catch (error) {
        console.error("图片上传失败:", error);
        Toast.fail(error.message || "图片上传失败，请重试");
        // 如果上传失败，从数组中移除该文件
        if (Array.isArray(file)) {
          data.imagesArray = data.imagesArray.filter(
            (item) => !file.includes(item)
          );
        } else {
          const index = data.imagesArray.indexOf(file);
          if (index > -1) {
            data.imagesArray.splice(index, 1);
          }
        }
        // 确保 imagesArray 始终是数组
        if (!Array.isArray(data.imagesArray)) {
          data.imagesArray = [];
        }
      }
    };

    const handleDelete = (file, detail) => {
      if (data.images) {
        const urls = data.images.split(",").filter((url) => url.trim());
        const index = detail.index;
        if (index >= 0 && index < urls.length) {
          urls.splice(index, 1);
          data.images = urls.join(",");
        }
      }
      // 确保 images 始终是数组
      if (!Array.isArray(data.imagesArray)) {
        data.imagesArray = [];
      }
    };

    const handleOversize = () => {
      const maxSize = envData.value.images_max_size || 5 * 1024 * 1024;
      const maxSizeMB = (maxSize / (1024 * 1024)).toFixed(2);
      Toast.fail(`图片大小不能超过 ${maxSizeMB}MB`);
    };

    return {
      // handleClick,
      onSubmit,
      ...toRefs(data),
      showJump,
      statementOverflows,
      bgColor: computed(() =>
        envData.value.bg_color ? envData.value.bg_color : "#ddd"
      ),
      showAddress: computed(() => envData.value.address_switch),
      showIdcard: computed(() => envData.value.idcard_switch),
      showImages: computed(() => envData.value.images_switch),
      btnColor: computed(() =>
        envData.value.btn_color ? envData.value.btn_color : "#ddd"
      ),
      envData,
      exinfo: computed(() =>
        navigator.userAgent.toLowerCase().indexOf("iphone") >= 0 ||
        navigator.userAgent.toLowerCase().indexOf("ipad") >= 0
          ? envData.value.iosExinfo
          : envData.value.androidExinfo
      ),
      handleLaunch,
      handleError,
      time,
      timeStatus,
      onFinish,
      descRef,
      isExpand,
      toggleExpand,
      handleAfterRead,
      handleDelete,
      handleOversize
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}
.content-tabs {
  width: 265px;
  height: 34px;
  margin: 4vw auto;
  border-radius: 17px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 1px 1px 1px 1px #e0e0e0;
  // z-index: 999;
  position: absolute;
  top: -8vw;
  left: 0;
  right: 0;
  .slot-title {
    font-weight: 600;
    font-size: 3.8vw;
    display: inline-block;
    height: 30px;
  }
  .line {
    width: 2px;
    height: 16px;
    background: #dbdbdb;
    position: absolute;
    right: 0;
    top: 10px;
  }
}

.ed-btn {
  position: absolute;
  top: 16vw;
  right: 0vw;
  background: #101010;
  opacity: 0.5 !important;
  border-radius: 6vw 0px 0px 6vw;
  padding: 0px 12px;
  span {
    font-size: 3.6vw;
    color: #ffffff;
  }
}
.van-cell {
  --van-cell-border-color: none;
  margin-bottom: 15px;
}

.serviceIcon {
  width: 50px;
  height: 50px;
  background: linear-gradient(to right, #608ef4, #314fe5);
  box-shadow: 2px 2px 5px 1px #a09c9c;
  padding: 4px;
  border-radius: 10px;
  position: fixed;
  bottom: 86px;
  right: 10px;
  z-index: 99;
}
.header {
  position: reactive;
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.form {
  position: relative;
  margin-left: 12px;
  margin-right: 12px;
  // margin-top: -20px;
  // padding-top: 30px;
  z-index: 3;
  position: relative;
  min-height: 55vh;
}

.form-content {
  padding: 16px 24px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
}
.title {
  font-size: 16px;
  margin-left: 2px;
  margin-bottom: 10px;
  .star {
    color: red;
  }
}

.field {
  border-radius: 10px;
  --van-cell-background-color: rgb(245, 247, 250);
  --van-cell-group-background-color: none;
  margin-bottom: 20px;
}
.fileList-field {
  --van-cell-horizontal-padding: 0px;
  --van-cell-vertical-padding: 0px;
}

.submit-btn {
  width: 50%;
  margin-top: 20px;
  margin-bottom: 30px;
}

.statement {
  position: absolute;
  z-index: 100;
  height: 26px;
  width: 60px;
  top: 31px;
  right: 0;
  background-color: rgba($color: #323233, $alpha: 0.7);
  border-radius: 12px 0 0 12px;
  color: white;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  .statement-title {
    line-height: 26px;
  }
}

#img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  -webkit-touch-callout: none;
}

.count-text {
  width: 100%;
  height: 28px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 14px;
  .time {
    line-height: 28px;
    font-size: 3.4vw;
  }
}

.copyright {
  width: 100%;
  height: 30px;
  margin-top: 20px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 0.8rem;
  color: white;
}
.hint {
  margin: 20px 12.5% 0;
  width: 75%;
}

.content-top {
  width: 100%;
  // height: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .new-content-box {
    padding: 20px;
    background: #fff;
    width: calc(100% - 24px);
    text-align: left;
    margin: 10px 12px;
    font-size: 14px;
    border-radius: 10px 10px 10px 10px;
    box-sizing: border-box;
    position: relative;

    .tip-expand {
      margin-top: 10px;
      text-align: center;
      height: 34px;
      line-height: 34px;
      font-size: 14px;
      color: rgb(68, 92, 214);
      background-color: #f6f7fb;
      border-radius: 4px;
    }
  }
  .content-top-desc {
    line-height: 1.5;
    overflow: hidden;
    transition: max-height 0.3s ease;

    &.expand {
      position: relative;
      max-height: 120px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: linear-gradient(to bottom, transparent, #fff);
      }
    }
  }
}
.icon-wrapper {
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.countDown {
  position: relative;
  z-index: 1;
  margin: -12px 14px 0;
  padding: 15px 8px;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  :deep(.van-count-down) {
    line-height: 32px;
    white-space: nowrap;
    .colon {
      color: #3d3d3d;
      font-weight: 700;
      font-size: 3.8vw;
    }
    .block {
      display: inline-block;
      padding: 0 0.5vw;
      text-align: center;
      height: 32px;
      line-height: 32px;
      border-radius: 2px;
      background-color: #ffe1d8;
      margin: 0 0.5vw;
      color: #ff5e2b;
      font-size: 5.8vw;
      font-weight: 700;
    }
  }
}
</style>
